@if (isMulti()) {
  <elcia-multi-dropdown [control]="control()"
                        [items]="statuses()"
                        [label]="'todo.status'  | translate"
                        [textField]="'name'"
                        [valueField]="'id'">
  </elcia-multi-dropdown>
} @else {
  <elcia-dropdown [control]="control()"
                  [items]="statuses()"
                  [label]="'todo.status' | translate"
                  [scrollHeight]="'140px'"
                  [textField]="'name'"
                  [valueField]="'id'">
    <ng-template #item let-item>
      <div class="flex gap-2">
        <div>
          <elcia-dot [color]="item.color"></elcia-dot>
        </div>
        <div>
          {{ item.name }}
        </div>
      </div>
    </ng-template>
  </elcia-dropdown>
}
